import { useEffect, useState } from 'react'
import { Button } from '#app/components/ui/button.tsx'

const COOKIE_CONSENT_KEY = 'vigilio_cookie_consent'

type ConsentValue = 'accepted' | 'declined'

function getConsent(): ConsentValue | null {
	if (typeof document === 'undefined') return null
	const match = document.cookie
		.split('; ')
		.find((row) => row.startsWith(`${COOKIE_CONSENT_KEY}=`))
	const value = match?.split('=')[1]
	if (value === 'accepted' || value === 'declined') return value
	return null
}

function setConsent(value: ConsentValue) {
	// Cookie expires in 1 year
	const maxAge = 365 * 24 * 60 * 60
	document.cookie = `${COOKIE_CONSENT_KEY}=${value}; path=/; max-age=${maxAge}; SameSite=Lax`
}

export function hasAnalyticsConsent(): boolean {
	return getConsent() === 'accepted'
}

export function CookieConsentBanner() {
	const [visible, setVisible] = useState(false)

	useEffect(() => {
		if (getConsent() === null) {
			setVisible(true)
		}
	}, [])

	if (!visible) return null

	const handleAccept = () => {
		setConsent('accepted')
		setVisible(false)
	}

	const handleDecline = () => {
		setConsent('declined')
		setVisible(false)
	}

	return (
		<div className="fixed bottom-0 left-0 right-0 z-50 border-t border-slate-200 bg-white p-4 shadow-lg">
			<div className="mx-auto flex max-w-4xl flex-col items-center gap-4 sm:flex-row">
				<p className="flex-1 text-sm text-slate-600">
					Nous utilisons des cookies analytiques pour améliorer
					votre expérience et diagnostiquer les problèmes
					techniques. Consultez notre{' '}
					<a
						href="/privacy"
						className="text-indigo-600 underline hover:text-indigo-700"
					>
						politique de confidentialité
					</a>{' '}
					pour en savoir plus.
				</p>
				<div className="flex shrink-0 gap-2">
					<Button variant="outline" size="sm" onClick={handleDecline}>
						Refuser
					</Button>
					<Button size="sm" onClick={handleAccept}>
						Accepter
					</Button>
				</div>
			</div>
		</div>
	)
}
